import React from 'react'
import { Link, Typography } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import makeStyles from '@mui/styles/makeStyles'
import { useTranslation } from '../../hooks/helper/useTranslation'

const useStyles = makeStyles((theme) => ({
  link: {
    color: theme.palette.common.white,
  },
}))

export const Law: React.FC = () => {
  const { t } = useTranslation()
  const classes = useStyles()

  return (
    <Link
      className={classes.link}
      component={RouterLink}
      to="/privacy-statement"
      underline="hover"
    >
      <Typography variant="body2">
        {t('footer:menu.privacyStatement')}
      </Typography>
    </Link>
  )
}
